module.exports = __webpack_public_path__ + "img/google_colored.3f6d31fc.svg";